// extracted by mini-css-extract-plugin
module.exports = {"button":"_1Z_5x","navigate":"_3_giS","header":"Ic3Cs","orderNumber":"PGtl0","placedOn":"VNrQp","actions":"cpVaE"};